import { useWallet } from "@solana/wallet-adapter-react";
import { useWalletModal } from "@solana/wallet-adapter-react-ui";
import SignMessage from "./SignMessage";

function ConnectWalletButton() {
  const { publicKey } = useWallet();

  const { setVisible } = useWalletModal();

  const connectWallet = () => {
    setVisible(true);
  };

  if (publicKey) {
    return (
      <div>
        &lt;p&gt;`Wallet with address ${publicKey.toString()}{" "}
        connected!`&lt;/p&gt;
        <SignMessage></SignMessage>
      </div>
    );
  } else {
    return (
      <p>
        <br />
        In order to claim, connect your SOL wallet that holds AI agent tokens 
        <br />
        &lt;button id="connect-wallet-btn"&gt;
        <a
          onClick={connectWallet}
          className="text-[#0fd] cursor-pointer underline"
        >
          Connect Wallet
        </a>
        &lt;/button&gt;
      </p>
    );
  }
}

export default ConnectWalletButton;
